/*
    logoAdjust.js
    microCMS「協賛N：ロゴの表示調整」（切り取り位置・拡大率）を画像のスタイルに変換します。
*/
const POSITIONS = {
    "切り取り：中央": "center",
    "切り取り：上": "top",
    "切り取り：下": "bottom",
    "切り取り：左": "left",
    "切り取り：右": "right",
};

const first = (v) => (Array.isArray(v) ? v[0] : v);

export function logoStyle(adjust) {
    const pos = POSITIONS[first(adjust?.position)];
    const zoom = parseInt(first(adjust?.zoom), 10);
    const scale = zoom > 0 ? zoom / 100 : 1;
    return {
        objectFit: pos ? "cover" : "contain",
        objectPosition: pos || "center",
        transform: scale !== 1 ? `scale(${scale})` : undefined,
        transformOrigin: pos || "center",
    };
}
